import workspaceQuery from '../../queries/sales/PaymentLinesQuery.graphql';
import fragment from '../../fragments/sales/PaymentLineFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const PaymentLine: EntityType = {
  type: 'PaymentLine',
  title: 'Payments',
  workspaceUrl: '/Sales/PaymentLines/Workspace/',
  workspace: workspaceQuery,
  fragment,
  screenReference: 'PAYMENT_LINE',
};

export default PaymentLine;
